import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import { withRouter } from 'react-router'
import compose from '@shopify/react-compose'

import RequestPhoneNumberView from './request-phone-number-view'

import editUserPhoneNumberValidator from 'validators/edit-user-phone-number'
import { updatePhoneNumber } from '@portal/kit/pkg/services'
import { handleServerErrors } from '@portal/kit/pkg/helpers'

class RequestPhoneNumberContainer extends Component {
  confirmPhoneNumber = async values => {
    try {
      const response = await updatePhoneNumber(values)
      this.props.user.setUser(response.data)
      this.props.nextStep()
    }
    catch(e) {
      return handleServerErrors(e)
    }
  }

  render() {
    return (
      <Form
        initialValues={this.props.user.data}
        onSubmit={this.confirmPhoneNumber}
        validate={values => editUserPhoneNumberValidator(this.props.user.data, values)}
        render={formProps => <RequestPhoneNumberView {...formProps} />}
      />
    )
  }
}

RequestPhoneNumberContainer.propTypes = {
  user: PropTypes.object.isRequired
}

export default compose(
  withRouter,
)(RequestPhoneNumberContainer)
